"use client";

import LastCollection from "./sections/LastCollection";
import OthersCollections from "./sections/OthersCollections";
import { BreadcrumbHomepage } from "@/components/sections/breadcrumb-homepage/BreadcrumbHomepage";

import { getCloudinaryUrl } from "@/lib/cloudinary";
import { Banner } from "@/components/sections/Banner";
import { GiftCardSection } from "@/components/sections/GiftCardSection";

const AboutPage = () => {
  return (
    <>
      <main className="flex min-h-screen max-w-[100vw] flex-col items-center justify-between">
        <Banner title="Collections" backgroundImage={getCloudinaryUrl("collections-banner")} />
        <BreadcrumbHomepage />
        <LastCollection />
        <OthersCollections />
        <GiftCardSection />
      </main>
    </>
  );
};

export default AboutPage;
